import styles from "./InfoBubblesMini.module.css";
import classNames from "classnames";
import { ButtonHTMLAttributes } from "react";
import { useI18n } from "../../i18n";
import { companyPaysNothing } from "../../state";
import { InfoBubblesInnerProps } from "./InfoBubblesTypes.ts";

export const InfoBubblesMini = (props: InfoBubblesInnerProps) => {
  const { bikeSavings, monthlyRate, bubbleClickHandler, companyPays } = props;

  const doesCompanyPayNothing = companyPaysNothing(companyPays);

  return (
    <div className={styles.infoBubblesMini}>
      <MiniBubble
        id="JobRadRechner_MiniBubble_MonthlyRate"
        variant="pink"
        value={monthlyRate}
        labelKey="miniBubbles.monthlyRateLabel"
        onClick={() => bubbleClickHandler("monthlyRate")}
      ></MiniBubble>
      {doesCompanyPayNothing ? null : (
        <MiniBubble
          id="JobRadRechner_MiniBubble_EmployerPaidCosts"
          variant="green"
          value={companyPays?.totalCosts}
          labelKey="miniBubbles.employerPaidCostsLabel"
          onClick={() => bubbleClickHandler("employerPaidCosts")}
        ></MiniBubble>
      )}
      <MiniBubble
        id="JobRadRechner_MiniBubble_Savings"
        variant="green"
        value={bikeSavings}
        labelKey="miniBubbles.bikeSavingsLabel"
        onClick={() => bubbleClickHandler("bikeSavings")}
      ></MiniBubble>
    </div>
  );
};

type MiniBubbleProps = {
  variant: "pink" | "green";
  labelKey: string;
  value: number | undefined;
} & ButtonHTMLAttributes<HTMLButtonElement>;

const MiniBubble = (props: MiniBubbleProps) => {
  const { variant, labelKey, value, ...buttonProps } = props;

  const { t, locale, formatNumber } = useI18n();

  const elementClassNames = classNames(styles.miniBubble, [styles[variant]]);

  return (
    <button type="button" className={elementClassNames} {...buttonProps} data-testid={props.id}>
      <span className={styles.value}>
        {`${formatNumber(value!, { negativeAllowed: false })} ${locale.currencySymbol}`}
      </span>
      <span className={styles.label}>{t(labelKey)}</span>
    </button>
  );
};
